// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1589434a","404":"bf97f044","464":"fdce1890","596":"b1a922f0","670":"0de75f8f","862":"e9996640"}[chunkId] + ".chunk.js";
};